import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { AcquiringItem } from 'app/dataTypes/acquiring/settings'

import { Header } from '../FundColumns'
import PayTypeBankCart from './PayTypeBankCart'
import RefillLoading from './RefillLoading'

import styles from './Step3.module.scss';

type Props = {
  acquiringItem: AcquiringItem | null
  amount: string
  onPrev: () => void
  onNext: () => void
}

const Step3 = ({ acquiringItem, amount, onPrev, onNext }: Props) => {
  const { t } = useTranslation('finances')

  const amountFloat = parseFloat(amount)

  useEffect(() => {
    if (Number.isNaN(amountFloat)) {
      onPrev()
    }
  }, [amountFloat]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header>{t('payment_type_choose_header', 'Выберите способ оплаты')}</Header>
      {Number.isNaN(amountFloat) && <RefillLoading itemsCount={1} />}
      {!Number.isNaN(amountFloat) && (
        <PayTypeBankCart
          className={styles.bankCard}
          amount={amountFloat}
          acquiringItem={acquiringItem}
          onRefillClick={onNext}
        />
      )}

      <ControlsBar className={styles.buttons}>
        <PlainButton outline onClick={onPrev}>
          {t('back_bt', 'Назад')}
        </PlainButton>
      </ControlsBar>
    </>
  )
}

export default Step3
